import React from "react";
import { Text } from "@react-pdf/renderer";

export const renderMultilingualText = (text, styles = {}) => {
  if (!text || typeof text !== "string") {
    return null;
  }

  const regex = /([\u3400-\u9FBF]+)/g;
  const parts = text.split(regex).filter(Boolean);

  return (
    <Text>
      {parts.map((part, index) => {
        const isChinese = /[\u3400-\u9FBF]/.test(part);
        const style = isChinese ? [styles.fontChinese, styles.textXs] : [styles.fontThai, styles.textMs];
        return (
          <Text key={index} style={style}>
            {part}
          </Text>
        );
      })}
    </Text>
  );
};
